import { orderBy } from 'lodash-es';

import { MobileIssueTypeCount } from 'src/common/types/MobileSingleSessionTypes';

import { MfaSessionIssueTypesQuery } from '../MfaSessionIssueTypes.generated';

export const transformMfaSessionIssueTypesResults = (
	rawResults: MfaSessionIssueTypesQuery
): MobileIssueTypeCount[] => {
	const issueTypes = rawResults.mfa_test_by_issue_types || [];

	// Calculate total issues across all types
	const totalIssues = issueTypes.reduce((sum, issueType) => sum + (issueType.total_issues || 0), 0);

	// Transform aggregated data into MobileIssueTypeCount objects and sort by count (descending)
	return orderBy(
		issueTypes.map((issueType) => ({
			type: issueType.type_name,
			count: issueType.total_issues,
			totalIssues,
			severity: issueType.severity_name
		})),
		['count'],
		['desc']
	);
};
